import script from "./CommonInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommonInput.vue?vue&type=script&setup=true&lang=ts"

import "./CommonInput.vue?vue&type=style&index=0&id=928291e6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-928291e6"]])

export default __exports__